import { prompt, type PromptDefinition } from './models';

export const PORTFOLIO_MANAGER_PROMPTS = [
    prompt(
        'Understand it',
        'What compliance gaps in this building should I raise in the portfolio review?',
        'Which buildings should lead the portfolio compliance action list?'
    ),
    prompt(
        'Understand it',
        'Which maintenance issues in this building need escalation to portfolio management?',
        'Which buildings stand out for recurring maintenance issues in the portfolio?'
    ),
    prompt(
        'Understand it',
        'What are the main documented risks to escalate for this building?',
        'Rank my buildings for management review using documented risks and evidence gaps.'
    ),
    prompt(
        'Understand it',
        'Find portfolio-review evidence for this building about…',
        'Find portfolio-review evidence across my buildings about…',
        'prefill'
    ),
    prompt(
        'Keep it running',
        'Which proposed capital works for this building need a portfolio-level decision?',
        'Compare documented capital-work priorities across my buildings.'
    ),
    prompt(
        'Meet obligations',
        'Which reporting gaps in this building could distort the portfolio picture?',
        'Which buildings have missing or stale records affecting portfolio reporting?'
    ),
    prompt(
        'Understand it',
        "What progress is recorded against this building's outstanding management actions?",
        'Which buildings are falling behind on recorded management actions?'
    ),
    prompt(
        'Understand it',
        'Find management action plans for this building relating to…',
        'Find management action plans across my buildings relating to…',
        'prefill'
    ),
    prompt(
        'Coordinate people',
        "Where are decision owners unclear for this building's escalated issues?",
        'Which portfolio issues lack a clear decision owner across my buildings?'
    ),
    prompt(
        'Understand it',
        "What changed in this building's recent reports that warrants escalation?",
        'Which buildings have newly reported issues needing portfolio attention?'
    ),
    prompt(
        'Understand it',
        'Prepare an evidence-based management summary for this building.',
        'Summarise cross-building trends and exceptions for my portfolio review.'
    ),
    prompt(
        'Understand it',
        'Prepare a portfolio-review note for this building focused on…',
        'Compare and prioritise my buildings using evidence about…',
        'prefill'
    ),
] as const satisfies readonly PromptDefinition[];
